import { ParameterTypes } from "./parameter-types";
export class OptionalParameterDefinition {
}
OptionalParameterDefinition.String = {
    type: ParameterTypes.String,
    optional: true
};
OptionalParameterDefinition.StringArray = {
    type: ParameterTypes.StringArray,
    optional: true
};
OptionalParameterDefinition.Boolean = {
    type: ParameterTypes.Boolean,
    optional: true
};
OptionalParameterDefinition.BooleanArray = {
    type: ParameterTypes.BooleanArray,
    optional: true
};
OptionalParameterDefinition.Number = {
    type: ParameterTypes.Number,
    optional: true
};
OptionalParameterDefinition.NumberArray = {
    type: ParameterTypes.NumberArray,
    optional: true
};
OptionalParameterDefinition.Date = {
    type: ParameterTypes.Date,
    optional: true
};
OptionalParameterDefinition.DateArray = {
    type: ParameterTypes.DateArray,
    optional: true
};
